import React, { Component } from 'react';
import './Gauge.css';

const maxGaugeRotation = 180;

export default class Gauge extends Component {
    render() {
        let gaugeRotation = Math.floor(this.props.value * 179 / this.props.maxValueMinutes) + 1;
        let serviceStateClass = 'gauge-value';

        gaugeRotation = gaugeRotation > maxGaugeRotation ? maxGaugeRotation : gaugeRotation;
        gaugeRotation = this.props.value ? gaugeRotation : 1;
        const maskStyle = { transform: `rotate(${gaugeRotation}deg)` };

        serviceStateClass += this.props.value > this.props.maxValueMinutes / 2 ? ' service-overloaded' : ' service-ok';

        return (
            <div className="gauge-box">
                <div className="mask">
                    <div className="semi-circle"></div>
                    <div className="semi-circle--mask" style={ maskStyle }></div>
                </div>
                <span className={ serviceStateClass }>{ this.props.value || '-' }</span>
                <span className="gauge-label">{ this.props.label }</span>
            </div>
        );
    }
}
